// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__1ONbm","label":"LabeledBox_label__2I8Vt"};